import { ProductLinesToIcon } from "../../../constant/common.constant";

import { ProductLinesToColor } from "../../../constant/common.constant";
import { ProductLineType } from "../../../types";
import { useTranslation } from "react-i18next";
import { Box, Icon } from "../../../common/components";

interface Props {
  productLine: ProductLineType;
}

const ProductLineToDisplayTag = ({ productLine }: Props) => {
  const { t } = useTranslation();
  return (
    <Box
      display="inline-flex"
      alignItems="center"
      gap={"2px"}
      sx={{
        display: "inline-flex",
        verticalAlign: "middle",
        whiteSpace: "nowrap",
      }}
    >
      <Icon
        icon={ProductLinesToIcon[productLine]}
        color={ProductLinesToColor[productLine]}
        size={14}
        style={{
          marginBottom: "1px",
        }}
      />
      <span
        style={{
          fontWeight: 700,
          color: ProductLinesToColor[productLine],
        }}
      >
        {t(`line.${productLine}.title`)}
      </span>
    </Box>
  );
};

export default ProductLineToDisplayTag;
